export default "__VITE_ASSET__D80h0Zdu__"